import { ImageTemplates } from "~/components/image/types";
import { WindowFormat } from "~/context/breakpoints/types";

export const imageTemplates: ImageTemplates = {
  [WindowFormat.mobile]: "imagebanner-mobile",
  [WindowFormat.tablet]: "imagebanner-tablet",
  [WindowFormat.desktop]: "imagebanner-regulardesktop",
  [WindowFormat.wideDesktop]: "imagebanner-largedesktop",
};
export const GENERIC_TEXT_IMAGE_BANNER_PREFIX = "GenericTextImageBanner";

export const GENERIC_TEXT_IMAGE_BANNER_CLASSES = {
  grid: `${GENERIC_TEXT_IMAGE_BANNER_PREFIX}-grid`,
  title: `${GENERIC_TEXT_IMAGE_BANNER_PREFIX}-title`,
  text: `${GENERIC_TEXT_IMAGE_BANNER_PREFIX}-text`,
  image: `${GENERIC_TEXT_IMAGE_BANNER_PREFIX}-image`,
};
